import { FocusStyle } from './focusStyle'

export class DynamicSelect {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        container: '.dynamic-select',
        containerFormSelect: '.dynamic-select--form-select',
        default: '.dynamic-select__default',
        current: '.dynamic-select__current',
        options: '.dynamic-select__options',
        optionsActive: '.dynamic-select__active',
        allOptions: '.dynamic-select__options a',
        firstOption: '.dynamic-select__options a:eq(0)',
        selectField: 'select:not(.form__select--no-replace)',
        search: '.dynamic-select__search'
      },
      classes: {
        container: 'dynamic-select',
        containerFormSelect: 'dynamic-select--form-select',
        options: 'dynamic-select__options',
        optionsActive: 'dynamic-select__active',
        default: 'dynamic-select__default',
        current: 'dynamic-select__current',
        openOptions: 'dynamic-select--open',
        search: 'dynamic-select__search'
      }
    },
    settings)
  }

  init () {
    const that = this

    const intervalTimer = window.setInterval(function () {
      let counter = 0
      $(that.options.selectors.selectField)
        .each(function () {
          const select = $(this)
          if (select.find('option').length > 1) {
            counter++
          }
        })
      if (counter === $(that.options.selectors.selectField).length) {
        that.replaceSelectFields()
        that.addDefaults()
        that.addEvents()
        clearInterval(intervalTimer)
      }
    }, 1000)
  }

  replaceSelectFields () {
    const that = this

    $(that.options.selectors.selectField)
      .each(function () {
        const select = $(this)

        select
          .after('<div class="' + that.options.classes.container + '"><div class="' + that.options.classes.options + '"></div></div>')

        const container = select.next(that.options.selectors.container)
        const options = container.find(that.options.selectors.options)

        container
          .addClass(that.options.classes.containerFormSelect)
        options.prepend('<input class="' + that.options.classes.search + '" name="dropdown-search" placeholder="Suchen" />')
        for (let i = 0; i < select.find('option').length; i++) {
          const link = $('<a>')
          const option = select.find('option').eq(i)

          if (select.find('option').eq(i).is(':selected')) {
            container
              .prepend('<div class="' + that.options.classes.default + '">' + option.text() + '</div>')

            link
              .addClass(that.options.classes.optionsActive)
          }

          link
            .data('value', option.val())
            .data('select', select)
            .text(option.text())

          options
            .append(link)
        }

        // hide select
        select
          .hide()
      })
  }

  addDefaults () {
    const that = this
    const focusStyle = new FocusStyle()

    $(that.options.selectors.container)
      .each(function () {
        const container = $(this)

        const defaultElement = container.find(that.options.selectors.default)

        let currentText

        if (defaultElement.length > 0) {
          currentText = defaultElement.text()
        } else {
          currentText = container.find(that.options.selectors.firstOption).text()
        }

        container
          .prepend("<button class='" + that.options.classes.current + "'>" + currentText + '</button>')
      })

    // Add focus styling
    focusStyle.addFocusEvents(that.options.selectors.current)
  }

  addEvents () {
    const that = this

    $(that.options.selectors.container)
      .on('keydown', that.options.selectors.current, function (event) {
        const currentButton = $(this)

        const container = currentButton.closest(that.options.selectors.container)

        const options = container.find(that.options.selectors.options)

        const focusedOption = options.find(that.options.selectors.optionsActive) || options.children.first()

        // Space (32) or Enter (13)
        if (event.keyCode === 32 || event.keyCode === 13) {
          if (container.hasClass(that.options.classes.openOptions)) {
            focusedOption
              .trigger('click')

            currentButton
              .focus()
          } else {
            container.addClass(that.options.classes.openOptions)
          }
          return false

        // Down
        } else if (event.keyCode === 40) {
          if (container.hasClass(that.options.classes.openOptions)) {
            const nextOption = focusedOption.next('a')

            if (nextOption.length > 0) {
              focusedOption
                .removeClass(that.options.classes.optionsActive)

              nextOption
                .addClass(that.options.classes.optionsActive)
            }
          } else {
            container.addClass(that.options.classes.openOptions)
          }
          return false

        // Up
        } else if (event.keyCode === 38) {
          if (container.hasClass(that.options.classes.openOptions)) {
            const previousOption = focusedOption.prev('a')

            if (previousOption.length > 0) {
              focusedOption
                .removeClass(that.options.classes.optionsActive)

              previousOption
                .addClass(that.options.classes.optionsActive)
            }
          } else {
            container.addClass(that.options.classes.openOptions)
          }
          return false

        // Escape (27) or Tab (9)
        } else if (event.keyCode === 27 || event.keyCode === 9) {
          if (container.hasClass(that.options.classes.openOptions)) {
            container.removeClass(that.options.classes.openOptions)

            currentButton
              .focus()
          }
        }
      })

    $(that.options.selectors.current)
      .on({
        click: function (event) {
          $(this).parent().find(that.options.selectors.options).find(that.options.selectors.search).focus()
          const currentElement = $(event.target)

          const currentContainer = currentElement.closest(that.options.selectors.container)

          event.preventDefault()

          if (currentContainer.hasClass(that.options.classes.openOptions)) {
            currentContainer
              .removeClass(that.options.classes.openOptions)

            return false
          }

          const keyDownEvent = $.Event('keydown', { keyCode: 13 })

          $(that.options.selectors.current)
            .not(currentElement)
            .closest(that.options.selectors.container)
            .removeClass(that.options.classes.openOptions)

          $(this)
            .trigger(keyDownEvent)
        }
      })

    $(that.options.selectors.search).on('keyup', function () {
      const value = $(this).val().toLowerCase()
      $(this).parent().find('a').filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
        return $(this).text().toLowerCase().indexOf(value) > -1
      })
    })

    $(that.options.selectors.containerFormSelect)
      .find(that.options.selectors.allOptions)
      .on({
        click: function () {
          $(that.options.selectors.containerFormSelect).find(that.options.selectors.search).val('')
          const thisElement = $(this)

          const container = thisElement.closest(that.options.selectors.container)

          const current = container.find(that.options.selectors.current)

          $(thisElement.data('select'))
            .val(thisElement.data('value'))
            .trigger('change')

          thisElement
            .add(thisElement.nextAll())
            .add(thisElement.prevAll())
            .removeClass(that.options.classes.optionsActive)

          current
            .text(thisElement.text())

          thisElement
            .addClass(that.options.classes.optionsActive)
            .closest(that.options.selectors.container)
            .removeClass(that.options.classes.openOptions)
        }
      })

    $('body')
      .on({
        click: function (event) {
          if ($(event.target).closest(that.options.selectors.container).length === 0 || $(event.target).parent().hasClass('dynamic-select__options')) {
            $(that.options.selectors.container)
              .removeClass(that.options.classes.openOptions)
          }
        }
      })
  }
}

export default DynamicSelect
